import React, { useState, useEffect, useContext, useMemo } from "react";

// custome hooks
import usePriceSeprator from "../../../hooks/usePriceSeparator";

// Context
import { UserContext } from "../../Context/UserContextProvider";

import axios from "../../../axios/index";

// styles
import styles from "./UserMyReminders.module.css";
import Dstyles from "../UserMyAds/UserMyAds.module.css";
import loaderStyles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";

// components
import HomeNavbar from "./../../Home/HomeNavbar/HomeNavbar";
import UserSideDashboard from "../UserSideDashboard/UserSideDashboard";
import Footer from "../../Home/Footer/Footer";
import MyNotesCard from "../../Dashboard/Notes/MyNotes/MyNotesCard";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import SaleReminderCard from "../../Dashboard/Reminders/SaleReminderCard";
import RentReminderCard from "../../Dashboard/Reminders/RentReminderCard";
import CustomPagination from "../../CustomPagination/CustomPagination";

export default function UserMyReminders() {
  const { userToken } = useContext(UserContext);
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });
  const [cardData, setCardData] = useState();
  const [carRentData, setCardRentData] = useState();
  const [notesData, setNotesData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const [filterCardsByCategory, setFilterCardsByCategory] = useState({
    files: true,
    notes: false,
  });

  useMemo(() => cardData, [cardData]);
  useMemo(() => notesData, [notesData]);

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)
      const getNotes = await axios.get("Reminder/GetNotes?take=20&pageId=1", {
        headers: { authorization: "Bearer " + userToken },
      });

      const getSalesData = await axios.get("Reminder/GetEstates?take=20&pageId=1", {
        headers: { authorization: "Bearer " + userToken },
      });

      if (filterCardsByCategory.files) {
        setPage(prev => {
          return { ...prev, pageNumber: 1, pageCount: getSalesData.data.data.pageCount };
        });
      } else if (filterCardsByCategory.notes) {
        setPage(prev => {
          return { ...prev, pageNumber: 1, pageCount: getNotes.data.data.pageCount };
        });
      }

      const salesData = await getSalesData.data.data.data;
      const salesCard = await salesData?.filter(item => item.totalPrice !== 0);
      const rentsCard = await salesData?.filter(item => item.rentPrice !== 0);
      setCardData(salesCard);
      setCardRentData(rentsCard);
      setNotesData(getNotes.data.data.data);

      setIsLoading(false);
    };

    dataHandler();
  }, [userToken, filterCardsByCategory]);

  return (
    <>
      {isLoading ? (
        <div className={loaderStyles.loader_container}>
          <div className={loaderStyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir="rtl">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar />
            <div className="container py-3 px-0 mt-4">
              <div className="w-100 d-flex justify-content-md-between justify-content-center align-items-start">
                <UserSideDashboard reminder />
                <div className={`d-flex flex-column align-items-center justify-content-start p-md-4 p-3 ${Dstyles.main_container}`}>
                  <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mb-5">
                    <div className={`my-md-0 my-2 ${Dstyles.title}`}>یادآور من</div>
                  </div>

                  <div className="w-100 d-flex align-items-center justify-content-start mb-4">
                    <div className={`d-flex align-items-center justify-content-between ${Dstyles.filter_btns_right_container}`}>
                      <div
                        className={filterCardsByCategory.notes ? Dstyles.selected_card_category : Dstyles.unselected_card_category}
                        onClick={cardHandler}
                        id="notes"
                        style={filterCardsByCategory.notes ? { marginRight: ".25rem" } : { marginRight: "1.5rem" }}>
                        یادداشت‌ها
                      </div>
                      <div
                        className={filterCardsByCategory.files ? Dstyles.selected_card_category : Dstyles.unselected_card_category}
                        onClick={cardHandler}
                        id="files"
                        style={filterCardsByCategory.files ? { marginLeft: "0.25rem" } : { marginLeft: "1.5rem" }}>
                        املاک من
                      </div>
                    </div>
                  </div>

                  <div className="w-100 text-center">
                    {filterCardsByCategory.files ? (
                      <div
                        className={`w-100 d-flex justify-content-xl-between justify-content-center flex-wrap align-items-center mt-3 ${styles.cards_container}`}
                        dir="rtl">
                        {cardData == "" || carRentData == "" ? (
                          <div
                            className={`w-100 d-flex align-items-center justify-content-center ${loaderStyles.notfound_text}`}
                            style={{ minHeight: "397px" }}>
                            هنوز هیچ موردی برای نمایش وجود ندارد
                          </div>
                        ) : (
                          <>
                            <SaleReminderCard cardData={cardData} usePriceSeprator={usePriceSeprator} user myFiles />
                            <RentReminderCard rentsCard={carRentData} usePriceSeprator={usePriceSeprator} user myFiles />
                          </>
                        )}
                      </div>
                    ) : (
                      <MyNotesCard notesData={notesData} reminder user />
                    )}
                  </div>

                  <Stack
                    className={loaderStyles.pagination}
                    spacing={1}
                    sx={{
                      direction: "ltr",
                      bottom: "0",
                      height: "85px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center !important",
                    }}>
                    <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                  </Stack>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );

  function cardHandler(event) {
    if (event.target.id === "files") {
      setFilterCardsByCategory(prev => {
        return { ...prev, files: true, notes: false };
      });
    } else if (event.target.id === "notes") {
      setFilterCardsByCategory(prev => {
        return { ...prev, notes: true, files: false };
      });
    }
  }

  async function paginationHandler(event, value) {
    setIsLoading(true);
    if (filterCardsByCategory.files) {
      const getSalesData = await axios.get(`Reminder/GetEstates?take=20&PageId=${value}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      setPage(prev => {
        return { ...prev, pageNumber: value, pageCount: getSalesData.data.data.pageCount };
      });
      const salesData = await getSalesData.data.data.data;
      const salesCard = await salesData?.filter(item => item.totalPrice !== 0);
      const rentsCard = await salesData?.filter(item => item.rentPrice !== 0);
      setCardData(salesCard);
      setCardRentData(rentsCard);
      setIsLoading(false);
    } else if (filterCardsByCategory.notes) {
      const getNotes = await axios.get(`Reminder/GetNotes?take=20&PageId=${value}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      setPage(prev => {
        return { ...prev, pageNumber: value, pageCount: getNotes.data.data.pageCount };
      });
      setNotesData(getNotes.data.data.data);
      setIsLoading(false);
    }
  }
}
